import { Link } from "react-router-dom";
import { MapPin, Globe } from "lucide-react";
import { fcfa, resolveImg, offerFromPrice } from "@/lib/api";

export default function OfferCard({ offer }) {
  const fromPrice = offerFromPrice(offer);
  return (
    <Link
      to={`/offer/${offer.id}`}
      data-testid={`offer-card-${offer.id}`}
      className="group block bg-white rounded-2xl overflow-hidden soft-shadow card-hover border border-gray-100"
    >
      <div className="relative h-52 overflow-hidden bg-secondary">
        {offer.photos?.[0] ? (
          <img
            src={resolveImg(offer.photos[0])}
            alt={offer.title}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-muted-foreground">
            <Globe className="h-10 w-10" />
          </div>
        )}
        <span className="absolute top-3 left-3 bg-accent text-accent-foreground text-xs font-bold px-3 py-1 rounded-full capitalize">
          {offer.type === "hotel" ? "Hôtel" : "Séjour"}
        </span>
        {offer.active === false && (
          <span className="absolute top-3 right-3 bg-destructive text-white text-xs font-bold px-3 py-1 rounded-full">
            Désactivée
          </span>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center gap-1 text-muted-foreground text-xs mb-1">
          <MapPin className="h-3.5 w-3.5" /> {offer.destination}
        </div>
        <h3 className="font-head font-bold text-primary text-lg leading-tight mb-2 line-clamp-2">{offer.title}</h3>
        <div className="flex items-center gap-1 text-muted-foreground text-xs mb-3">
          <Globe className="h-3.5 w-3.5" /> {offer.departure_prices?.length || 0} pays de départ
        </div>
        <div className="flex items-end justify-between">
          <div>
            <div className="text-[11px] text-muted-foreground">à partir de</div>
            <div className="font-head font-extrabold text-accent text-xl">{fcfa(fromPrice)}</div>
            <div className="text-[11px] text-muted-foreground">par personne</div>
          </div>
          <span className="text-sm font-semibold text-primary group-hover:text-accent">Voir →</span>
        </div>
      </div>
    </Link>
  );
}
